import React, {Component} from "react";
import { TabberButton } from "../custom-form/tabber-button.component";
import Icons from "../../icon";
import { InventoryConfirmation } from "../../external/inventory/modal/inventory-confirmation.component";
import { ACTION_TYPES, MAX_LENGTH, TYPE_FUNCTION } from "../../../constants/external-constants";
import { CustomSearchableSelectKeyValue } from "../custom-form/input-filter-component";
import Translation from '../../common/translation/translation.component';
import { Button } from "react-bootstrap";
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
import { ORFCheckbox } from "../forms/order-request-form.component";

class TableWithButton extends Component {
    constructor(props) {
        super(props);
        this.ShowUpdateBtn = this.ShowUpdateBtn.bind(this)
        this.state = {
            showUpdateBtn: false,
            deleteIndex: 0,
            editMode: false,
            dataItem: this.props.datatable,
            selectedGlCode: null,
            selectedCostCenter: null,
            percent: null,
            editModeIndex: null,
            headerCount: 0,
            showDltModal: false,
            fileChange: false,  
            value: false,    
            isUpdateData:false
        }
    }

    componentDidMount() {
        this.calculateHeaderCount();       
    }

    componentDidUpdate(prevProps) {
        if (prevProps.datatable !== this.props.datatable) {
            this.calculateHeaderCount();                
        }
        if (prevProps.enableEdit !== this.props.enableEdit) {
            if(!this.props.enableEdit) {
             this.HideUpdateBtn();        
             this.disableEditMode();       
            }
        }
    }

    calculateHeaderCount = () => {
        let count = 0;
        this.props.datatable.forEach(item => {
            item.HeaderItem.forEach(header => {
                const columns = Object.values(header).sort((a, b) => (a.order - b.order));
                const visibleColumns = columns.filter(row => row.hidden === false);
                count += visibleColumns.length;
            });
        });
        if (this.props.haveToggle) {
            count += 3;
        }
        this.setState({count: count});
    }

    ShowUpdateBtn(index) {
        this.setState({            
            showUpdateBtn: true,
            fileChange: false
        })
        this.enableEditMode();
    }
    HideUpdateBtn() {
        this.setState({ showUpdateBtn: false })
        if (typeof this.props.handelEnableEdit === TYPE_FUNCTION) {
             this.props.handelEnableEdit(false,null)  
        }
        this.disableEditMode()
    }

    enableEditMode = () => {
        this.setState((prevState) => ({
            editMode: true
        }));
    };

    disableEditMode = () => {
        this.setState((prevState) => ({            
            editMode: false
        }));
    }

    enableUpdate() {
        if (typeof this.props.enableUpdate === TYPE_FUNCTION) {
            this.props.enableUpdate(true)
        }
        if (typeof this.props.toggleDropdown === TYPE_FUNCTION) {
            this.props.toggleDropdown()
        }
        if (typeof this.props.showDetails === TYPE_FUNCTION) {
            this.props.showDetails(false);
        }
    }

    renderTableDataValue(props, item, c) {
        return item[this.getProp(props.datatable[0].HeaderItem[0], c.name)];
    }

    getProp(columns, name) {
        return Object.entries(columns)
            .filter((x) => {
                return x[1].name === name;
            })
            .map((x) => x[0])[0];
    }

    checkBoxValue = (isChecked, index) =>{
        if (typeof this.props.getCheckboxValue === TYPE_FUNCTION) {
            this.props.getCheckboxValue(isChecked, index)
        }
    }    

    renderTableData = (item, itemKey) => {
        const { haveCheckBox, enableCheckBox, defaultCheckBoxValue, defaultSelected } = this.props
         const headerItem = this.props.datatable[0].HeaderItem[0];
        // const headerLength = Object.values(headerItem).filter(value => !value.hidden).length - 1;
        var checkBoxValue = this.checkCheckBoxValue(itemKey, defaultCheckBoxValue, defaultSelected);
        let listIndex = 0;

        return Object.values(headerItem).map((value, index) => {
            if (!value.hidden) {
                const result = (
                    <td
                        className="col-text-overflow"
                        key={"td-" + value.name + "-" + Object.keys(value)[0]}
                        hidden={value.hidden}
                    >
                        <div className="table-checkbox-container">
                            {(listIndex === 0 && haveCheckBox) && 
                                <ORFCheckbox
                                    checkBoxValue={(isChecked)=> this.checkBoxValue(isChecked, itemKey)}
                                    initialValue={checkBoxValue}
                                    disable={!enableCheckBox}
                                    classWrapper="custom-checkbox-wrapper"/>  }
                            {this.renderTableDataValue(this.props, item, value)}
                        </div>   
                    </td>
                );
                listIndex++; // Increment the visible index only if the column is not hidden
                return result;
            }
        });
    };

    checkCheckBoxValue = (itemKey, defaultCheckBoxValue, defaultSelected) => {
        if (defaultSelected == null || defaultSelected == undefined) {
            if (defaultCheckBoxValue !== undefined) {
                return defaultCheckBoxValue;
            } else {
                return true;
            }
        } else {
            if ((defaultSelected.includes(itemKey))) {
                return true;
            } else {
                if (defaultCheckBoxValue !== undefined) {
                    return defaultCheckBoxValue;
                } else {
                    return true;
                }
            }
        }
    }

    handleTableChange = (index, value, e) => {
        const newDataTable = this.props.datatable.map((item, itemIndex) => {
            if (itemIndex === index) {
                return {
                    ...item,
                    [value]:e.target.value
                };
            }
        })
        this.setState({dataTable: newDataTable})
    }

    rowClick(index) {
        this.props.rowClickAction(index);
    }


    handleInputValue(value, e){
       this.setState({fileChange:true})
       this.props.handleInputChange(value, e)       
    }

    callHandleGetFieldData = (index) => {
        if (this.props.datatable && this.props.datatable.length > 0) {
            const { dataItem, HeaderItem } = this.props.datatable[0];
    
            if (dataItem && dataItem.length > index) {
                const data = dataItem[index];
                const header = HeaderItem[0];
    
                for (let propName in header) {
                    let value = header[propName];
    
                    if (!value.hidden && 
                        (this.props.searchableDropdownData.includes(value.propName) ||
                        this.props.inputField.includes(value.propName))) {
                        
                        const dataValue = data[value.propName];
    
                        if (typeof this.props.handleGetFieldData === 'function') {
                            this.props.handleGetFieldData(value.propName, dataValue);
                        }
                    }
                }
            }
        }
    }
        

    //create a function here that will render a modal
    handleBtnClick = (action, index) => {
        if (action === 'update') {
            this.callHandleGetFieldData(index);
            this.setState({
                editModeIndex: index,
                isUpdateData: false
            }, () => {
                this.disableEditMode();
                this.handleTableUpdate(action, index);
            });
            if (typeof this.props.clearSelectedValue === 'function') {
                this.props.clearSelectedValue()
            }
        } else {
            this.setState({
                showDltModal: true,
                deleteIndex: index
            });
        }
    };
    

    handleDeleteModal = (btnType, index) => {
        const {deleteAction, handleOpenNotif} = this.props;
        if (btnType === CONFIRMATION_VALUE.Ok){
            deleteAction(this.state.deleteIndex);          
        }
        this.setState(prev => ({showDltModal: !prev}));    
    }

    handleUpdateData =(index)=>{
        this.setState({ isUpdateData: true });
         const {updateAction, handleOpenNotif} = this.props;         
         updateAction(index)     
    }

    handleTableUpdate = (btnType, index) =>{ 
       if (typeof this.props.handelEnableEdit === TYPE_FUNCTION) { 
            this.props.handelEnableEdit(true,this.state.editModeIndex) 
       }         
       this.ShowUpdateBtn(index)
        this.setState(prev => ({showConfirmModal: !prev}));
    }


    renderEditTableData = (item, index) => {
        return Object.values(this.props.datatable[0].HeaderItem[0]).map((value, itemKey) => {
            if (!value.hidden) {
                if(this.props.searchableDropdownData.includes(value.propName))
                {
                    var dataValue = ""                   
                    dataValue = this.props.selectedItems?.[value.propName] || item[value.propName]
                    return (
                        <td key={"td-" + value.name + "-" + Object.keys(value)[0]}>
                            <CustomSearchableSelectKeyValue
                                options={this.props.optionsMap?.[value.propName] ?? []}
                                selected={dataValue ? dataValue : ""}
                                onChange={(e)=>this.props.handleSelectChange(value.propName, e, this.state.editModeIndex)}
                                maxLength={MAX_LENGTH.limit_100}
                                customClass={this.props.isUpdateGl_Cost & this.state.isUpdateData ? 'border-red' : ''}
                            />
                        </td>
                    );
                } else if(this.props.inputField.includes(value.propName)){
                        var dataValue=""
                        if(this.state.fileChange)
                        {
                            dataValue= this.props.selectedItems?.[value.propName]
                        }else {
                            dataValue= item[value.propName]
                        }     
                        
                        if(this.props.enableEdit && this.props.selectedItems?.[value.propName]) {
                            dataValue= this.props.selectedItems?.[value.propName]
                        }

                        if(dataValue==="") {
                            dataValue=this.props.percentValue
                        }
                                      
                        return (                          
                            <td key={"td-" + value.name + "-" + Object.keys(value)[0]}>
                                <input
                                    className={this.props.isUpdatePercent & this.state.isUpdateData & this.props.isGreater ? 'border-red' : ''}
                                    type="number"
                                    value={dataValue}
                                    onChange={(e) => this.handleInputValue(value.propName, e)}
                                    maxLength={MAX_LENGTH.inputText}
                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
                                />
                            </td>
                        )
                } else {
                    var dataValue = this.props.selectedItems?.[value.propName]
                    if(dataValue)
                    {
                        return (
                            <td key={"td-" + value.name + "-" + Object.keys(value)[0]}>
                              { dataValue}
                            </td>
                        )
                    }
                    return (
                        <td key={"td-" + value.name + "-" + Object.keys(value)[0]}>
                            {
                                this.renderTableDataValue(this.props, item, value)
                            }
                        </td>
                    )
                }                
            }
        }); 
    };

    render() {
        return (
            <div className={this.props.classNameWrapper}>
                 <ConfirmationNotificationModal 
                    show={this.state.showDltModal} 
                    message={'Are you sure you want to delete?'}
                    title={'Delete'} 
                    handleModal={(btnType) => this.handleDeleteModal(btnType, this.state.deleteIndex)}
                    customClass={'comment-notification-modal modal-text-bold'}
                    />
                <table className="details-view-table">
                    <thead>
                        <tr>
                            {this.props.datatable.map((item) => {
                                return item.HeaderItem.map((header, key) => {
                                    var columns = Object.values(header).sort((a, b) => (a.order - b.order))
                                    return (
                                        columns.map((row, index) => {
                                            return row.hidden === false && <th key={index}>{row.name}</th>
                                        })
                                    )
                                })
                            })}
                            {this.props.haveToggle &&
                                <>
                                    <th>Read</th>
                                    <th>Write</th>
                                    <th>Execute</th>
                                </>
                            }
                        </tr>
                    </thead>

                    <tbody >
                        {this.props.datatable.map((item, ounterIndex) => {
                           if(item.dataItem.length > 0){
                            return item.dataItem.map((dataItem, itemKey) => (
                                <tr key={itemKey}   onClick={this.props.haveCheckBox ? null : (this.props.haveEditBtn ? this.enableUpdate.bind(this) : () => this.rowClick(itemKey))} className="row-item">
                                    {
                                        (this.state.editMode  &&  this.state.editModeIndex === itemKey) ||
                                         ((this.state.editMode===false && this.props.enableEdit) && itemKey===this.props.keyIndex) ? (
                                            this.renderEditTableData(dataItem, itemKey)
                                        ) :
                                            this.renderTableData(dataItem, itemKey)
                                    }
                                    {this.props.haveToggle &&
                                        <>
                                            <td>
                                                <TabberButton />
                                            </td>
                                            <td>
                                                <TabberButton />
                                            </td>
                                            <td>
                                                <TabberButton />
                                            </td>
                                        </>
                                    }
                                    {
                                        (this.props.haveDeleteBtn || this.props.haveEditBtn) &&
                                        <td className={`edit-btn-container ${this.state.editMode ? "update-btn-container" : ""}`}>
                                        
                                            {/* ACTION BUTTONS */}
                                            
                                            {
                                                (this.state.showUpdateBtn && this.state.editModeIndex === itemKey)
                                                ||
                                                ((this.state.showUpdateBtn===false && this.props.enableEdit) && itemKey===this.props.keyIndex)
                                                ?
                                                    <div className="update-icon-container">
                                                        <Icons
                                                            customClassName="icon-xmark-reg"
                                                            name="xmark"
                                                            size="20px"
                                                            containerClass="icon-circle-plus-container"
                                                            onClick={this.HideUpdateBtn.bind(this)}
                                                        />
                                                            
                                                            <Icons
                                                            customClassName="icon-check-reg"
                                                            name="check"
                                                            size="20px"
                                                            containerClass="icon-circle-plus-container"  
                                                            onClick={() =>this.handleUpdateData(itemKey)}
                                                            /> 
                                                    </div>
                                                    :
                                                    <div className="update-icon-container">
                                                        {this.props.haveDeleteBtn &&
                                                                
                                                                <>                                                                   
                                                                    <Icons
                                                                    customClassName="icon-trash"
                                                                    name="trash-can"
                                                                    size="20px"
                                                                    containerClass="icon-circle-plus-container"
                                                                    onClick={() => this.handleBtnClick('delete', itemKey)}
                                                                    />
                                                                </>
                                                        }

                                                        {this.props.haveEditBtn &&
                                                         <>
                                                            <ConfirmationNotificationModal 
                                                            show={this.state.showConfirmModal} 
                                                            message={'Are you sure you want to update?'}
                                                            title={'Update'} 
                                                            handleModal={(btnType) => this.handleTableUpdate(btnType, itemKey)}
                                                            customClass={'comment-notification-modal modal-text-bold'}
                                                            />
                                                            <Icons
                                                                customClassName="icon-pen-light"
                                                                name="pen-light"
                                                                size="20px"
                                                                containerClass="icon-circle-plus-container"
                                                                onClick={() =>this.handleBtnClick('update',itemKey)}                                                               
                                                            />
                                                         </>
                                                        }
                                                    </div>

                                            }

                                        </td>
                                    }
                                </tr>
                            )
                            )

                           } else {
                                return (
                                    <tr key={"tr-0"}>
                                        <td colSpan={this.state.count}>
                                            <h4 className="table-no-results text-align-center">
                                                <Translation translationKey="no_data_available" />
                                            </h4>
                                        </td>
                                    </tr>
                                );
                           }
                        }
                        )}
                    </tbody>
                </table>
                {/* Delete */}              
                {this.props.haveExternalDeleteBtn &&
                 <>                   
                    <div className="delete-buttons-container">
                        { this.props.datatable.map((item, index) => (
                                item.dataItem.map((listItem, indexItem) =>
                                    <div key={indexItem} className="delete-button-row">
                                    <Icons
                                            customClassName="icon-trash"
                                            name="trash-can"
                                            size="20px"
                                            containerClass="icon-circle-plus-container"
                                            onClick={()=>this.handleBtnClick('delete',indexItem)}
                                        />
                                    </div>
                                )
                            )) }                   
                    </div>
                 </>
                }
                
            </div>
        );
    }
}

export default TableWithButton